import React from "react";
import { SelectFileIcon } from "../../SVGIcons";

interface FileUploadDropzoneProps {
  inputId: string;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDragOver: (e: React.DragEvent<HTMLLabelElement>) => void;
  onDragLeave: (e: React.DragEvent<HTMLLabelElement>) => void;
  onDrop: (e: React.DragEvent<HTMLLabelElement>) => void;
  hasExtractionResult?: boolean;
  onUseExtractionResult?: () => void;
}

export const FileUploadDropzone: React.FC<FileUploadDropzoneProps> = ({
  inputId,
  onFileSelect,
  onDragOver,
  onDragLeave,
  onDrop,
  hasExtractionResult,
  onUseExtractionResult,
}) => {
  return (
    <div className="flex h-full w-full">
      {/* 左側：新規アップロード */}
      <div className={`flex-1 flex flex-col items-center justify-center ${hasExtractionResult ? 'border-r border-gray-300' : ''}`}>
        <label
          className="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
          htmlFor={inputId}
          onDragLeave={onDragLeave}
          onDragOver={onDragOver}
          onDrop={onDrop}
        >
          <div className="flex flex-col items-center justify-center pt-5 pb-6 space-y-3">
            <SelectFileIcon className="w-12 h-12 text-gray-500" />
            <p className="mb-2 text-sm text-gray-500">
              <strong className="font-semibold text-blue-600">
                マイソク画像を選択、またはドラッグ＆ドロップ
              </strong>
            </p>
            <p className="text-xs text-gray-500">
              JPEG, PNG, WebP, PDFが使用可能（5MBまで）
            </p>
            <div className="px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
              画像を選択
            </div>
          </div>
          <input
            accept="image/png, image/jpeg, image/webp, application/pdf, .pdf"
            aria-label="マイソク画像を選択"
            className="hidden"
            id={inputId}
            multiple={false}
            onChange={onFileSelect}
            type="file"
          />
        </label>
      </div>

      {/* 右側：間取り抜き出し結果を使用（結果がある場合） */}
      {hasExtractionResult && onUseExtractionResult && (
        <div className="flex-1 flex flex-col items-center justify-center bg-orange-50">
          <h3 className="text-sm font-semibold mb-2 text-gray-700">または</h3>
          <button
            onClick={onUseExtractionResult}
            className="px-6 py-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 font-medium"
          >
            間取り抜き出し結果を使う
          </button>
          <p className="text-xs text-gray-500 mt-2">
            先ほど抜き出した間取り図を使用します
          </p>
        </div>
      )}
    </div>
  );
};

export default FileUploadDropzone;
